import { styled, mq, BreakpointKey } from '@thg-commerce/gravity-theme'
import {
  BreakpointVisibility,
  Visibility,
} from '@thg-commerce/gravity-patterns/Header/types'

export const VisibilityHelper = styled.div<{
  visibility: BreakpointVisibility
}>`
  ${(props) =>
    Object.entries(props.visibility).map(([breakpoint, visible]) => {
      return `${mq(
        props.theme.breakpointUtils.map,
        breakpoint as BreakpointKey,
      )} {
      display: ${visible === Visibility.HIDE ? 'none' : 'block'};
    }`
    })}
`
